import { render, staticRenderFns } from "./packingStatus.vue?vue&type=template&id=1ad015f7&scoped=true"
import script from "./packingStatus.vue?vue&type=script&lang=js"
export * from "./packingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad015f7",
  null
  
)

export default component.exports